import Node from "../components/Base/Node.vue";
import RadioButton from "../components/Base/RadioButton.vue";
import Select from "../components/Base/Select.vue";
import TileGrid from "../components/Base/TileGrid.vue";
import TileGridItem from "../components/Base/TileGridItem.vue";
import TextField from "../components/Base/TextField.vue";
import HtmlContent from "../components/Base/HtmlContent.vue";

const components = {
  Node,
  RadioButton,
  Select,
  TileGrid,
  TileGridItem,
  TextField,
  HtmlContent,
};

export const useBaseComponents = () => ({
  install(app) {
    for (const [name, component] of Object.entries(components)) {
      app.component(`Base${name}`, component);
    }
  },
});
